import get from 'lodash-es/get';
import set from 'lodash-es/set';
import merge from 'lodash-es/merge';

import { CalculationDataByKeysInterface } from 'app/shared/interfaces/CalculationDataByKeys.interface';
import { FieldsEnum } from 'app/shared/enums';
import { UserInterface } from 'app/shared/interfaces/User.interface';

export default function getInitialValues(
  initialValues: CalculationDataByKeysInterface,
  user: UserInterface
) {
  const calcToUserStateMap = {
    [FieldsEnum.InsurancePhoneNumber]: 'phoneNumber',
    [FieldsEnum.InsurantEmail]: 'username',
  };
  const hasNoInitializedValue = (calcFormKey: string) => {
    const value = get(initialValues, calcFormKey);
    return value === null || value === undefined;
  };

  const prepareDefaultDataForKeys = (
    defaultDataFromUserState: CalculationDataByKeysInterface,
    calcFormKey: FieldsEnum
  ) => {
    const userStateKey = calcToUserStateMap[calcFormKey];
    const dataFromUser = get(user, userStateKey, null);
    set(defaultDataFromUserState, calcFormKey, dataFromUser);
    return defaultDataFromUserState;
  };

  const dataFromUserState = Object.keys(calcToUserStateMap)
    .filter(hasNoInitializedValue)
    .reduce<CalculationDataByKeysInterface>(
      prepareDefaultDataForKeys,
      {} as CalculationDataByKeysInterface
    );

  return merge(initialValues, dataFromUserState);
}
